import React, { useEffect,useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import NavBanner from './NavBanner/NavBanner'
import NavAndDividends from './NavAndDividends/NavAndDividends'
import LatestNav from './LatestNav/LatestNav'
import { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import NavHistory from "./NavHistory/NavHistory";
import LatestDividend from "./LatestDividend/LatestDividend";
import DividendHistory from "./DividendHistory/DividendHistory";

function Dividend() {
    const [value, setValue] = React.useState(1);
    const [pathname, setPathName] = useState('');
    useEffect(() => {
        const pathname = window.location.pathname;
        const lastSegment = pathname.slice(pathname.lastIndexOf('/') + 1);
        const CategoryIdUrlid = lastSegment;
        setPathName(CategoryIdUrlid);
    })
    const arrayOfTabsObj = [
        { name: "Latest IDCW", id: 1 },
        { name: "IDCW History", id: 2 },
        // { name: "Corporate Profile", id: 3 },     
        // { name: "Trustee", id: 4 },
        // { name: "The AMC", id: 5 },
        // { name: "Sponsor", id: 6 },
        // { name: "Auditor", id: 7 },
        // { name: "Custodian", id: 8 },
        // { name: "Registar", id: 9 },

    ];
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    useEffect(() => {
        var para = window.location.pathname.toLocaleLowerCase().split('/')[2];
        if (para === "ourcororpate") setValue(3)
        if (para === "theamc") setValue(6)

        if (para === "sponsor") setValue(7)
        if (para === "auditors") setValue(8)
        if (para === "custodian") setValue(9)
        if (para === "registrars") setValue(10)
    }, []);
    return (
        <>
            <section className="nav-section-head">
                {/* <Container>
                    <Row>
                        <Col>
                        <ul className="navigator-arrow">
                    <li><a href="/"><i class="fa fa-home" aria-hidden="true"></i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/NavsAndIDCW"><i>NavsAndIDCW</i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    {window.location.pathname != "/NavsAndIDCW" ? <li>{pathname.replace(/([a-z])([A-Z])/g, '$1 $2')}</li> : ''}
                </ul>
                        </Col>
                    </Row>
                </Container> */}
           
                <div className="nav-heading">
                    <h1>IDCW (Dividend)</h1>
                </div>
            </section>
            <section className="Nav-Section">
                <Container>
                    <Row>
                        <Col sm={12}>
                            <Box sx={{ width: "100%" }}>
                                <TabContext value={value}>
                                    <Box
                                        sx={{
                                            borderBottom: 0,
                                            borderColor: "divider",
                                            bgcolor: "background.paper",
                                        }}
                                    >
                                        <TabList
                                            onChange={handleChange}
                                            variant="scrollable"
                                            sx={{
                                                [`& .${tabsClasses.scrollButtons}`]: {
                                                    "&.Mui-disabled": { opacity: 0.3 },
                                                },
                                            }}
                                            scrollButtons="auto"
                                        >
                                            {arrayOfTabsObj.map((item) => (
                                                <Tab className={item.id == 3 ? "width185" : "width125"} label={item.name} value={item.id}></Tab>
                                            ))}
                                        </TabList>
                                    </Box>
                                    <TabPanel value={1}>
                                        {/* <Vision></Vision> */}
                                        <LatestDividend />
                                    </TabPanel>
                                    <TabPanel value={2}>
                                        {/* <Values></Values> */}
                                        <DividendHistory />
                                    </TabPanel>
                                </TabContext>
                            </Box>
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    )
}

export default Dividend